// @flow

import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  ControlLabel,
  FormControl
} from "react-bootstrap";
import auth from "../../../services/auth";
import Popup from "react-popup";
import { history } from "../../../redux/store/configureStore";
import { Redirect, Link } from "react-router-dom";
import { connect } from "react-redux";
import "../../../style/login.css";
import imageURL from "../../../img/ddb-logo.png";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      login_token: "",
      logout_response: "",
      submitted: false,
      login_response: "",
      msgType: null,
      msg: null,
      hover: false,
    };
  }

  isAuthenticated() {
    const token = auth.getToken();
    return token && token.length > 10;
  }

  renderAlert() {
    if (this.state.msgType && this.state.msg) {
      let msgClass =
        this.state.msgType == "error"
          ? "alert alert-danger"
          : "alert alert-" + this.state.msgType;
      return (
        <div className={msgClass}>
          <a href="#" className="close" data-dismiss="alert" aria-label="close">
            &times;
          </a>
          <strong>{this.state.msgType.toUpperCase()} :</strong> {this.state.msg}
        </div>
      );
    }
  }

  render() {
    const { email, password, submitted } = this.state;
    const { isLogging } = this.props;
    const isAlreadyAuthenticated = this.isAuthenticated();

    return (
      <div>
        <Col md={6} mdOffset={3}>
          <div className="panel margin-top margin-bottom">
              <Row className="margin-top margin-bottom">
                <Col md={12} xs={12}>
                <Col md={12} xs={12}>
                  {this.renderAlert()}
                </Col>
                <Col md={12} xs={12}>
                  <Row>
                    <Col md={12} xs={12} className="text-center">
                        <img src={imageURL} width="35%" />
                    </Col>
                    <Col md={12} xs={12} className="text-center">
                      <h1>Sub Admin Login</h1>
                    </Col>
                    <Col md={12} xs={12}>
                      <hr/>
                    </Col>
                    <Col md={12} xs={12}>
                      {isAlreadyAuthenticated ? (
                        localStorage.getItem("userTypeName") == "customer" ? (
                          <Redirect to={{ pathname: "./" }} />
                        ) : (
                          <Redirect to={{ pathname: "./dashboard" }} />
                        )
                      ) : (
                        <form className="form-horizontal" noValidate>
                          <Col md={12} xs={12}>
                            <FormGroup controlId="cpassword">
                              <FormControl
                                type="text"
                                value={email}
                                placeholder="Email Address"
                                name="email"
                                autoComplete="off"
                                onChange={this.handlesOnEmailChange}
                              />
                            </FormGroup>
                          </Col>
                          <Col md={12} xs={12}>
                            <FormGroup controlId="inputPassword">
                              <FormControl
                                type="password"
                                value={password}
                                placeholder="Password"
                                name="email"
                                autoComplete="off"
                                onChange={this.handlesOnPasswordChange}
                              />
                            </FormGroup>
                          </Col>
                          <Row>
                            <Col md={6} xs={12}>
                              <Button
                                className="login-button"                     
                                bsStyle="success"
                                disabled={isLogging}
                                type="submit"
                                onClick={this.handlesOnLogin.bind(this)}
                              >
                                {isLogging ? (
                                  <span>
                                    login in... &nbsp;
                                    <i className="fa fa-spinner fa-pulse fa-fw" />
                                  </span>
                                ) : (
                                  <span>Login</span>
                                )}
                              </Button>
                            </Col>
                            <Col md={6} xs={12}>
                              <Link replace to={"/forgot"} className="pull-right">
                                Lost your password ?
                              </Link>
                            </Col>
                          </Row>
                        </form>
                      )}
                    </Col>
                  </Row>
                </Col>
                </Col>
              </Row>
          </div>
        </Col>
      </div>
    );
  }
  // #endregion

  handlesOnEmailChange = (event: SyntheticEvent<>) => {
    if (event) {
      event.preventDefault();
      this.setState({ email: event.target.value.trim() });
    }
  };

  handlesOnPasswordChange = (event: SyntheticEvent<>) => {
    if (event) {
      event.preventDefault();
      // should add some validator before setState in real use cases
      this.setState({ password: event.target.value.trim() });
    }
  };

  componentWillMount(){
    if(this.props.themeData){
      if(this.props.themeData.button){
        this.setState({
          button_color: this.props.themeData.button.button_color,
          mouseover_color: this.props.themeData.button.mouseover_color,
        });
      }
    }
  }
  
  componentWillReceiveProps(nextProps) {
    if(nextProps.themeData){
      if(nextProps.themeData.button){
        this.setState({
          button_color: nextProps.themeData.button.button_color,
          mouseover_color: nextProps.themeData.button.mouseover_color,
        });
      }
    }
    
    if (nextProps.loginResponse.error)
      this.setState({ msgType: "error", msg: nextProps.loginResponse.error });
  }

  // #region on login button click callback
  handlesOnLogin = async (event: SyntheticEvent<>) => {
    if (event) {
      event.preventDefault();
    }

    this.setState({ submitted: true });
    const { email, password } = this.state;
    const { dispatch } = this.props;

    try {
      if (email && password) {
        this.props.login(email, password);
        this.setState({ msgType: null, msg: null });
      } else {
        this.setState({
          msgType: "error",
          msg: "Email and Password fields are required"
        });
      }
    } catch (error) {
      /* eslint-disable no-console */
      this.setState({ msgType: "error", msg: error });
      /* eslint-enable no-console */
    }
  };
  // #endregion

  // #region on go back home button click callback
  goHome = (event: SyntheticEvent<>) => {
    if (event) {
      event.preventDefault();
    }

    const { history } = this.props;

    history.push({ pathname: "/" });
  };
  // #endregion
}

export default Login;



// WEBPACK FOOTER //
// ./src/app/views/admin/login/Login.js